module.exports = __webpack_public_path__ + "img/trial2-3.4297a171.png";